import { SECURITY_PDF_REPORTS } from '../../../../shared/featureFlags/flagNames';
import { useIsFeatureEnabled, useIsSecurityEnabled } from '../../../helpers/features';

/**
 * A hook that returns if security / vulnerability report options can be displayed
 * @returns {boolean} - If security / vulnerability report options can be displayed
 */
export const useCanDisplaySecurityOptions = (): boolean => {
  const isSecurityFlagEnabled = useIsFeatureEnabled(SECURITY_PDF_REPORTS);
  const isSecurityEnabled = useIsSecurityEnabled();
  return isSecurityEnabled && isSecurityFlagEnabled;
};
